<template>
  <div class="site-manage-container">
    <Condition ref="condition" :onSearch="onSearch" :tabKey="tabKey" :typeSelect="typeSelect" />

    <div class="site-manage-tab-container">
      <TableHeadIcons
        style="position: relative"
        :onRefresh="onSearch"
        :size.sync="tableDensity"
        :columns="columns"
      >
        <div class="tab" :class="{ active: tabKey === '1' }" @click="onTabKeyChange('1')">新闻</div>
        <!-- <div class="tab" :class="{ active: tabKey === '2' }" @click="onTabKeyChange('2')">
          自媒体
        </div> -->
        <div class="tab" :class="{ active: tabKey === '3' }" @click="onTabKeyChange('3')">
          云采集 / 文献 / 微信公众号
        </div>

        <!-- <a-dropdown style="position: absolute; right: 120px">
          <a-menu slot="overlay">
            <a-menu-item @click.native="downloadTemplateFlag = true">下载导入模板</a-menu-item>
            <a-menu-item @click.native="uploadTemplateFlag = true">直接导入站点</a-menu-item>
          </a-menu>
          <a-button type="primary">批量导入站点 <a-icon type="down" /></a-button>
        </a-dropdown> -->
      </TableHeadIcons>
      <News ref="News" v-show="tabKey === '1'" :tableDensity="tableDensity" />
      <WeMedia ref="WeMedia" v-show="tabKey === '2'" :tableDensity="tableDensity" />
      <Api ref="Api" v-show="tabKey === '3'" :tableDensity="tableDensity" />
    </div>

    <a-modal
      title="下载导入模板"
      :visible="downloadTemplateFlag"
      @ok="downloadImportTemplate"
      @cancel="cancelDownload"
    >
      <p>导入模板类型</p>
      <a-checkbox-group v-model="selectedTypes">
        <a-row>
          <a-col :span="8" v-for="item in downloadType" :key="item.value">
            <a-checkbox style="margin-bottom: 15px" :value="item.value">{{ item.name }}</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </a-modal>

    <a-modal
      title="导入设置"
      :visible="uploadTemplateFlag"
      @ok="uploadImportTemplate"
      okText="确定导入"
      @cancel="cancelUpload"
    >
      <p>站点类型</p>
      <a-select v-model="uploadType" style="width: 200px" placeholder="请选择站点类型">
        <a-select-option v-for="item in downloadType" :key="item.value" :value="item.value">{{
          item.name
        }}</a-select-option>
      </a-select>
      <div style="margin-top: 20px">
        <a-upload
          accept=".xls,.xlsx"
          :file-list="fileList"
          :remove="handleRemove"
          :multiple="false"
          :before-upload="beforeUpload"
        >
          <a-button type="primary"> <a-icon type="upload" />选择文件</a-button>
          <span>（请按模板表格格式上传）</span>
        </a-upload>
      </div>
    </a-modal>

    <a-modal
      title="导入结果"
      :visible="uploadResultFlag"
      @ok="downloadUploadResult"
      okText="查看失败详情"
      cancleText="关闭"
      @cancel="uploadResultFlag = false"
    >
      <a-row style="text-align: center">
        <a-col :span="12">
          导入成功： <span class="upload-success">{{ uploadInfo.successNum }}</span>
        </a-col>
        <a-col :span="12">
          导入失败： <span class="upload-failure">{{ uploadInfo.failNum }}</span>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import TableHeadIcons from '@/components/TableHeadIcons'
import News from './News'
import WeMedia from './WeMedia'
import Api from './Api'
import Condition from './Condition'
import { uploadTemplate } from '@/api/Site/Manage'
import { contextPath } from '@/config/'

export default {
  name: 'adf',
  components: { News, WeMedia, Condition, TableHeadIcons, Api },

  data() {
    return {
      tabKey: '1',
      tableDensity: 'middle',
      columns: [],
      typeSelect: undefined,
      isShowColFilterOverlay: false,

      downloadTemplateFlag: false,
      downloadType: [
        { name: '新闻', value: 'news' },
        { name: '推特-账号', value: 'twitter_account' },
        { name: '推特-关键字', value: 'twitter_keyword' },
        { name: '微博', value: 'weibo' },
        { name: 'facebook', value: 'facebook' },
        { name: 'youtube', value: 'youtube' },
        { name: '云采集', value: 'api' },
        { name: '今日', value: 'toutiao' },
        { name: '文献', value: 'document' },
        { name: 'instagram', value: 'ins' },
        { name: 'telegram', value: 'tg' },
        { name: 'vk', value: 'vk' }
      ],
      selectedTypes: [],

      uploadTemplateFlag: false,
      uploadType: undefined,
      fileList: [],

      uploadResultFlag: false,
      uploadInfo: {}
    }
  },

  created() {
    this.onDefaultQuery().then(() => {
      this.$nextTick(this.getColumns)
      this.onReflesh()
      setTimeout(() => {
        this.onSearch()
        if (sessionStorage.types !== undefined) {
          switch (sessionStorage.types) {
            case 'news':
              this.onTabKeyChange('1')
              break
            case 'zimeiti':
              this.onTabKeyChange('2')
              break
            case 'others':
              this.onTabKeyChange('3')
              break
            default:
              break
          }
          sessionStorage.types = undefined
        }
      }, 200)
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/site_create_form' && to.path !== '/site_info') {
      sessionStorage.removeItem('condition')
    }
    this.$nextTick(() => {
      next()
    })
  },
  methods: {
    onDefaultQuery() {
      return new Promise((resolve) => {
        const { spiderClassId, type } = this.$route.query
        if (type) {
          switch (type) {
            case 'news':
              this.tabKey = '1'
              break
            case 'vk':
            case 'tg':
            case 'ins':
            case 'weMedia':
              this.tabKey = '2'
              this.typeSelect = spiderClassId
              break
            case 'toutiao':
              this.tabKey = '3'
              this.typeSelect = spiderClassId
              break
            case 'api':
              this.tabKey = '3'
              this.typeSelect = spiderClassId
              break
            case 'document':
              this.tabKey = '3'
              this.typeSelect = spiderClassId
            case 'wechat':
              this.tabKey = '3'
              this.typeSelect = spiderClassId
              break
          }
        }
        if (spiderClassId && type === 'weMedia') {
          this.$nextTick(() => {
            this.$refs.condition.preSaveSpiderClassId(parseInt(spiderClassId))
            this.$refs.WeMedia.search.spiderClassId = parseInt(spiderClassId)
            resolve()
          })
        } else if (
          spiderClassId &&
          (type === 'api' || type === 'toutiao' || type === 'document' || type === 'wechat')
        ) {
          this.$nextTick(() => {
            this.$refs.condition.preSaveSpiderApiClassId(parseInt(spiderClassId))
            this.$refs.Api.search.spiderClassId = parseInt(spiderClassId)
            resolve()
          })
        } else {
          this.$nextTick(() => resolve())
        }
      })
    },

    onTabKeyChange(key) {
      this.tabKey = key
      this.$refs.condition.changeValue()
      setTimeout(() => {
        this.getColumns()
        setTimeout(() => {
          this.onSearch()
        }, 200)
      }, 100)
    },

    onTableDensityChange(density) {
      this.tableDensity = density
    },

    async onSearch(condition = {}) {
      let childName
      let params = await this.$refs.condition.returnSearch()
      switch (this.tabKey) {
        case '1':
          childName = 'News'
          delete params.spiderClassId
          break
        case '2':
          childName = 'WeMedia'
          break
        case '3':
          childName = 'Api'
      }
      this.$store.commit('SET_PARAM', params)
      await this.$refs[childName].handleSearch(params)
    },

    onReflesh() {
      let childName
      switch (this.tabKey) {
        case '1':
          childName = 'News'
          break
        case '2':
          childName = 'WeMedia'
          break
        case '3':
          childName = 'Api'
      }
      this.$refs[childName].querySpiderList()
    },

    getColumns() {
      let childName
      switch (this.tabKey) {
        case '1':
          childName = 'News'
          break
        case '2':
          childName = 'WeMedia'
          break
        case '3':
          childName = 'Api'
      }
      this.columns = this.$refs[childName].columns
    },

    // 下载模板
    downloadImportTemplate() {
      if (!this.selectedTypes.length) {
        this.$message.error('请选择导入模板类型')
        return
      }
      this.selectedTypes.forEach((item, index) => {
        setTimeout(() => {
          window.location.href = `${contextPath}/spider/doc/importTemplate?spiderClassType=${item}`
        }, index * 1000)
      })
      this.cancelDownload()
    },
    cancelDownload() {
      this.downloadTemplateFlag = false
      this.selectedTypes = []
    },
    cancelUpload() {
      this.uploadTemplateFlag = false
      this.uploadType = undefined
      this.fileList = []
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    uploadImportTemplate() {
      const { fileList, uploadType } = this
      if (!uploadType) {
        this.$message.error('请选择站点类型')
        return
      }
      if (!fileList.length) {
        this.$message.error('请选择文件')
        return
      }
      const formData = new FormData()
      fileList.forEach((file) => {
        formData.append('file', file)
        formData.append('spiderClassType', uploadType)
      })
      uploadTemplate(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success('上传成功')
          this.cancelUpload()
          this.uploadInfo = res.extra.importResult
          this.uploadResultFlag = true
          this.onSearch()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    downloadUploadResult() {
      if (this.uploadInfo.failNum === 0) {
        this.$message.info('无失败数据下载')
        return
      }
      const logPath = this.uploadInfo.importFailUrl
      let downloadElement = document.createElement('a')
      let fileName = '错误报告.xls'
      downloadElement.href = logPath
      downloadElement.target = '_blank'
      downloadElement.download = fileName
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)

      this.uploadResultFlag = false
    }
  }
}
</script>

<style lang="less" scoped>
.site-manage-container {
  width: 100%;
  padding: 16px;

  .site-manage-tab-container {
    background: white;
    margin-top: 16px;
    padding: 0 16px;

    .tab {
      padding: 0 16px 12px;
      position: relative;
      cursor: pointer;
      font-size: 14px;

      &.active {
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          height: 2px;
          background: #0088ff;
        }
      }
    }

    .table-container {
      background: white;
      padding: 0 16px;
    }
  }
}
.upload-success {
  color: #40a9ff;
}
.upload-failure {
  color: #ff7875;
}
</style>
